import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { glassStyle, TargetHandle } from "./NodeHandles";
import { WebhookIcon } from "../icons/FlowIcons";

const EVENT_LABELS = {
  cart_abandonment: "Abandono",
  pix_generated: "PIX gerado",
  purchase_approved_new: "Pgto novo",
  purchase_approved_existing: "Pgto existente",
  payment_overdue: "Pgto atrasado",
  account_deactivated: "Desativado",
};

export default memo(({ data, isConnectable }) => {
  const eventLabel = data?.webhookEvent ? EVENT_LABELS[data.webhookEvent] || data.webhookEvent : null;

  return (
    <div style={{ ...glassStyle, minWidth: 140 }}>
      <TargetHandle isConnectable={isConnectable} />
      <div style={{ color: "var(--flow-text)", fontSize: "16px", flexDirection: "row", display: "flex", alignItems: "center", gap: 4 }}>
        <WebhookIcon size={16} style={{ color: "var(--flow-icon-color)" }} />
        <div style={{ color: "var(--flow-text)", fontSize: "16px" }}>Webhook</div>
      </div>
      <div style={{ color: "var(--flow-text-muted)", fontSize: "12px" }}>
        {data?.webhookPlatform && (
          <span style={{ textTransform: "capitalize" }}>{data.webhookPlatform}</span>
        )}
        {eventLabel && (
          <span style={{ color: "var(--flow-icon-color)", fontWeight: 600 }}>{" "}| {eventLabel}</span>
        )}
        {!data?.webhookPlatform && "Clique 2x para configurar"}
      </div>
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "var(--flow-handle-color)", width: "7px", height: "7px", top: "50%", right: "-6px", cursor: "pointer",
          border: "1px solid var(--flow-handle-color)", boxShadow: "0 0 4px var(--flow-node-shadow)",
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});

